import { createContext, useEffect, useState, useCallback } from "react";
import { SHARE_TOKEN_STORAGE_KEY } from "../axios/axiosFunctions";

const SHARE_INFO_KEY = "k2g_share_info";

export const ReportAccessContext = createContext({
    share: null,
    setShare: () => null,
    clearShare: () => null,
});

const readShareFromStorage = () => {
    try {
        const token = sessionStorage.getItem(SHARE_TOKEN_STORAGE_KEY);
        const infoRaw = sessionStorage.getItem(SHARE_INFO_KEY);
        if (!token || !infoRaw) return null;
        const info = JSON.parse(infoRaw);
        return { token, ...info };
    } catch {
        return null;
    }
};

export const ReportAccessProvider = ({ children }) => {
    const [share, setShareState] = useState(readShareFromStorage());

    const setShare = useCallback((next) => {
        if (!next || !next.token) {
            sessionStorage.removeItem(SHARE_TOKEN_STORAGE_KEY);
            sessionStorage.removeItem(SHARE_INFO_KEY);
            setShareState(null);
            return;
        }
        const { token, ...rest } = next;
        sessionStorage.setItem(SHARE_TOKEN_STORAGE_KEY, token);
        sessionStorage.setItem(SHARE_INFO_KEY, JSON.stringify(rest));
        setShareState(next);
    }, []);

    const clearShare = useCallback(() => setShare(null), [setShare]);

    // Cross-tab sync (sessionStorage doesn't fire 'storage' across tabs, but
    // if the tab is reused for normal login we don't want stale guest state).
    useEffect(() => {
        const refresh = () => setShareState(readShareFromStorage());
        window.addEventListener("focus", refresh);
        return () => window.removeEventListener("focus", refresh);
    }, []);

    return (
        <ReportAccessContext.Provider value={{ share, setShare, clearShare }}>
            {children}
        </ReportAccessContext.Provider>
    );
};
